/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Options/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Options({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/AppointmentOverlay/Content/PatientSelect/Content/Options"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let appointmentOverlayPatientOptionValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'patient_option',
})
let constantData = 'new'
let aggregateData = fromAggregate.equals(appointmentOverlayPatientOptionValueData, constantData)
let onClick = fromHelpers.useOnNew({
  children,
  viewPath
  
})
let appointmentOverlayPatientOptionValueData1 = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'patient_option',
})
let constantData1 = 'existing'
let aggregateData1 = fromAggregate.equals(appointmentOverlayPatientOptionValueData1, constantData1)
let onClick1 = fromHelpers.useOnExisting({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Options.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Options.Vertical:1"
  data-view-path={viewPath}
 style={{'--mb-1-tY85I': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Patient"
/>
</div>
<div
  data-testid="Options.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Options.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick}
 data="appointment_overlay.patient_option"
 data="'new'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 text="New patient"
/>
</div>
<div
  data-testid="Options.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick1}
 data="appointment_overlay.patient_option"
 data="'existing'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData1}
 text="Existing patient"
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}